import {
  Alert,
  Box,
  Button,
  Flex,
} from 'app/components/design-system-components'
import UpgradeButton from 'app/components/design-system-components/UpgradeButton'
import GetAICTA from 'app/components/display/smartdocs/upgradeCTAs/getAI'
import theme from 'app/match/applicationReportPDF/assets/theme'

function UpgradeCTAFromSetting({
  upgradeText = 'Get Snug Copilot',
  width = 'fit-content',
}) {
  return (
    <Alert variant="warningWithBg" mb={4} width={width}>
      <Flex alignItems="center">
        <UpgradeButton
          buttonContent={<GetAICTA />}
          isSmall={true}
          padding={`2px 8px`}
        />
        <Box
          ml={3}
          color={theme.colors.black}
          fontSize={theme.fontSizes.pRegular14}
        >
          {upgradeText}
        </Box>
        <Button
          variant="linkBlueWithoutWeight"
          ml={3}
          fontSize={theme.fontSizes.pSmall12}
          fontWeight={theme.fontWeights.small}
        >
          find out more
        </Button>
      </Flex>
    </Alert>
  )
}

export default UpgradeCTAFromSetting
